/* eslint-disable max-len */
import { SvgIconProps } from '@mui/material';
import React from 'react';

export function DocumentIcon({ fill, ...props }: SvgIconProps): React.ReactElement {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none" {...props}>
      <path
        d="M4.02344 20C3.62344 20 3.27344 19.8458 2.97344 19.5375C2.67344 19.2292 2.52344 18.8833 2.52344 18.5V5.5C2.52344 5.11667 2.67344 4.77083 2.97344 4.4625C3.27344 4.15417 3.62344 4 4.02344 4H11.0234L12.5234 5.5H21.0234C21.4068 5.5 21.7526 5.65417 22.0609 5.9625C22.3693 6.27083 22.5234 6.61667 22.5234 7V18.5C22.5234 18.8833 22.3693 19.2292 22.0609 19.5375C21.7526 19.8458 21.4068 20 21.0234 20H4.02344Z"
        fill={fill || 'white'}
      />
    </svg>
  );
}

export function ActiveDocumentIcon(): React.ReactElement {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
      <path
        d="M4.02344 20C3.62344 20 3.27344 19.8458 2.97344 19.5375C2.67344 19.2292 2.52344 18.8833 2.52344 18.5V5.5C2.52344 5.11667 2.67344 4.77083 2.97344 4.4625C3.27344 4.15417 3.62344 4 4.02344 4H11.0234L12.5234 5.5H21.0234C21.4068 5.5 21.7526 5.65417 22.0609 5.9625C22.3693 6.27083 22.5234 6.61667 22.5234 7V18.5C22.5234 18.8833 22.3693 19.2292 22.0609 19.5375C21.7526 19.8458 21.4068 20 21.0234 20H4.02344Z"
        fill="white"
      />
    </svg>
  );
}
